import { styled, keyframes, Box, Flex } from '@withjoy/joykit';

const loading = keyframes`
  to {
    background-position: -380% 0;
  }
`;

export const Skeleton = styled(Box)`
  animation: ${loading} 2.5s infinite;
  background-color: ${({ theme }) => theme.colors.mono2};
  background-image: linear-gradient(90deg, rgba(211, 211, 211, 0) 0, rgba(211, 211, 211, 0.4) 50%, rgba(211, 211, 211, 0) 100%);
  background-repeat: no-repeat;
  background-position: 388% 0;
  background-size: 50%;
  border-radius: 0.25rem;
  position: relative;
`;

export const Header = styled(Flex)`
  column-gap: 0.5rem;
  margin-bottom: 2.125rem;
  padding: 0 1.5rem;
  width: 83%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 2.5rem;
    padding: 0 3rem;
  }
`;

export const DateItem = styled(Skeleton)`
  height: 1.75rem;
  width: 7.7rem;
`;

export const ShareItem = styled(Skeleton)`
  height: 1.75rem;
  width: 2.5rem;
`;

export const LocationItem = styled(Skeleton)`
  height: 1.75rem;
  width: 7.7rem;
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    display: flex;
  }
`;

export const Section = styled(Flex)`
  flex-direction: column;
  margin-bottom: 1.5rem;
  padding: 0 1.5rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 3rem;
    margin-bottom: 1.75rem;
  }
`;

export const Title = styled(Skeleton)`
  height: 2.5rem;
  width: 11rem;
  margin-bottom: 0.5rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 1.875rem;
  }
`;

export const Content = styled(Skeleton)`
  height: 6.5rem;
  width: 20rem;
  max-width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 4.75rem;
  }
`;
